export interface TabNavItem {
  id: string;
  label: string;
}

interface TabNavProps {
  tabs: TabNavItem[];
  activeId: string;
  onChange: (id: string) => void;
}

/**
 * A simple controlled, underline-style tab bar for detail PAGES (the {@link Modal}
 * component has its own built-in tab bar for dialog editors). Mirrors the modal tab
 * styling so tabs look consistent across pages and dialogs.
 */
export function TabNav({ tabs, activeId, onChange }: TabNavProps): JSX.Element {
  return (
    <nav className="mb-4 flex gap-1 border-b border-slate-200" aria-label="Sections">
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            aria-current={active ? 'page' : undefined}
            className={`-mb-px border-b-2 px-3 py-2.5 text-sm font-medium ${
              active
                ? 'border-brand-600 text-brand-700'
                : 'border-transparent text-slate-500 hover:text-slate-700'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
